import * as React from 'react';
import { compose, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { LoginForm } from './LoginForm';
import { FadeTranslate } from 'ui/transitions';
import { LanguagePicker } from '../main/header/LanguagePicker';

import './LoginScreen.css';

export type Props = {
    loggedIn: boolean;
};

const fadeFrom = { y: '100%' };
const fadeTo = { y: '0%' };

export const RawLoginScreen = ({ loggedIn, copyright, styles }: Props & RecomposeProps & OemProps) =>
    <div
        id="login-screen"
        className={ loggedIn ? 'logged-in' : undefined }
        style={ styles.Workspace }
    >
        <LanguagePicker/>
    
        <div id="login-form-host">
            <LoginForm visible={ !loggedIn }/>

            <FadeTranslate
                visible={ !loggedIn }
                from={ fadeFrom }
                to={ fadeTo }
                duration={ 200 }
            >
                <p
                    className="copyright"
                    style={ styles.copyright }
                    dangerouslySetInnerHTML={ copyright }
                />
            </FadeTranslate>
        </div>
    </div>
;

type RecomposeProps = {
    copyright: {
        __html: string;
    };
};

export const LoginScreen = compose<Props & RecomposeProps & OemProps, Props>(
    translate(),
    skin,
    withProps(({ t, styles }: TranslateProps & OemProps) => ({
        styles: {
            copyright: {
                color: styles.Window.color,
            },
        },
        copyright: {
            __html: t('OEM_CopyrightWebClient', [ new Date().getFullYear().toString() ]).replace(/\\n/g, ' '),
        },
    })),
)(RawLoginScreen);



// WEBPACK FOOTER //
// ./src/ui/login/LoginScreen.tsx